export const state_list = [
    { "code": "AD", "name": "Andaman and Nicobar Islands" },
    { "code": "AE", "name": "Andhra Pradesh" },
    { "code": "AF", "name": "Assam" },
    { "code": "AF", "name": "Chandigarh" },
    { "code": "AF", "name": "Dadra and Nagar Haveli" },
    { "code": "AF", "name": "Delhi" },
    { "code": "AF", "name": "Gujarat" },
    { "code": "AF", "name": "Haryana" },
    { "code": "AF", "name": "Himachal Pradesh" },
    { "code": "AF", "name": "Jammu and Kashmir" },
    { "code": "AF", "name": "Lakshadweep" },
    { "code": "AF", "name": "Maharashtra" },
    { "code": "AF", "name": "Manipur" },
    { "code": "AF", "name": "Meghalaya" },
    { "code": "AF", "name": "Karnataka" },
    { "code": "AF", "name": "Nagaland" },
    { "code": "AF", "name": "Orissa" },
    { "code": "AF", "name": "Puducherry" },
    { "code": "AF", "name": "Punjab" },
    { "code": "AF", "name": "Rajasthan" },
    { "code": "AF", "name": "Tamil Nadu" },
    { "code": "AF", "name": "Tripura" },
    { "code": "AF", "name": "West Bengal" },
    { "code": "AF", "name": "Sikkim" },
    { "code": "AF", "name": "Arunachal Pradesh" },
    { "code": "AF", "name": "Mizoram" },
    { "code": "AF", "name": "Daman and Diu" },
    { "code": "AF", "name": "Goa" },
    { "code": "AF", "name": "Bihar" },
    { "code": "AF", "name": "Madhya Pradesh" },
    { "code": "AF", "name": "Uttar Pradesh" },
    { "code": "AF", "name": "Chhattisgarh" },
    { "code": "AF", "name": "Jharkhand" },
    { "code": "AF", "name": "Uttarakhand" },
    { "code": "AF", "name": "Other" }
  ]